import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const setupAppInsightsClient = (connectionString: string) => {
	let appInsights = null;

	if (typeof document !== 'undefined') {
		// Ensure it's only run on the client side
		appInsights = new ApplicationInsights({
			config: {
				connectionString: connectionString,
				enableAutoRouteTracking: true, // automatically track page changes
				disableFetchTracking: false, // track API calls
				disableExceptionTracking: false,
			},
		});

		appInsights.loadAppInsights();
		appInsights.trackPageView(); // initial load
	}
};
